import {
  Redirect,
  Route,
  Switch,
  useHistory,
  useParams,
  useRouteMatch,
} from 'react-router-dom';

import { useAssessmentActionsContext } from '~/lib/contexts/AssessmentActionsContext';
import { PatientCarePlanTab } from '~/components/maud/patients/profile/tabs/careplan/PatientCarePlanTab';
import { CarePlanView } from '~/components/maud/patients/profile/tabs/careplan/CarePlanView';
import DischargePlanView from '~/components/maud/patients/profile/tabs/careplan/dischargeplan/DischargePlanView';
import CarePlanningSubTabHeader, {
  CarePlanningTab,
  CarePlanningTabValue,
  CarePlanningSubTabProps,
} from '~/components/maud/patients/profile/tabs/careplan/CarePlanningSubTabHeader';

const CARE_PLANNING_TABS: CarePlanningSubTabProps[] = [
  { title: 'Care plan', value: CarePlanningTab.CARE_PLAN },
  { title: 'Discharge plan', value: CarePlanningTab.DISCHARGE_PLAN },
];

const CarePlanningPage = () => {
  const { patientId } = useParams<{ patientId: string }>();
  const { path, url } = useRouteMatch();
  const history = useHistory();
  const { updateAssessmentState } = useAssessmentActionsContext();

  const subTabMatch = useRouteMatch<{ subTab: string }>(`${path}/:subTab`);
  const activeSubTab: CarePlanningTabValue =
    subTabMatch?.params?.subTab === CarePlanningTab.DISCHARGE_PLAN
      ? CarePlanningTab.DISCHARGE_PLAN
      : CarePlanningTab.CARE_PLAN;

  const handleSubTabChange = (tab: CarePlanningTabValue) => {
    history.push(`${url}/${tab}`);
  };

  if (!patientId) return null;

  return (
    <PatientCarePlanTab
      patientId={patientId}
      updateAssessmentState={updateAssessmentState}
    >
      <CarePlanningSubTabHeader
        onTabChange={handleSubTabChange}
        selectedTab={activeSubTab}
        tabs={CARE_PLANNING_TABS}
      />
      <Switch>
        <Route exact path={`${path}/${CarePlanningTab.CARE_PLAN}`}>
          <CarePlanView patientId={patientId} />
        </Route>
        <Route exact path={`${path}/${CarePlanningTab.DISCHARGE_PLAN}`}>
          <DischargePlanView patientId={patientId} />
        </Route>
        <Redirect to={`${url}/${CarePlanningTab.CARE_PLAN}`} />
      </Switch>
    </PatientCarePlanTab>
  );
};

export default CarePlanningPage;
